import { render, staticRenderFns } from "./ColorView.vue?vue&type=template&id=633d7930"
import script from "./ColorView.vue?vue&type=script&lang=js"
export * from "./ColorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports